import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("be1-lang") : null;
    return saved && ["az", "en", "ru"].includes(saved) ? saved : "az";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("be1-lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const changeLang = useCallback((next) => {
    if (["az", "en", "ru"].includes(next)) setLang(next);
  }, []);

  const t = translations[lang] || translations.az;

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
